<template>
  <v-snackbar
    top
    color="success text-center"
    class="subtitle-1"
    :timeout="$spec.snakebar_timeout"
    v-model="saveReportSnackbar"
    vertical
  >
    <span v-text="hint"></span>
  </v-snackbar>
</template>
<style scoped>
.v-snack--top {
  top: 40px;
}
</style>
<script>
export default {
  data: () => ({
    saveReportSnackbar: false,
    hint: ""
  }),
  methods: {
    show(hint) {
      this.hint = hint;
      this.saveReportSnackbar = true;
    }
  }
};
</script>